module.exports = __webpack_public_path__ + "img/icon_eth_inventory.652cc43.png";